import { constants } from '#utils/reduxUtils';

export const forms = constants('forms', ['FOCUS', 'BLUR', 'INITIALIZE', 'DESTROY', 'DISABLE_SUBMIT', 'ENABLE_SUBMIT']);
